module.exports = __webpack_public_path__ + "7f1006844712c8c96d5e1ac045c62192.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-0.png
// module id = 1656
// module chunks = 0